// extracted by mini-css-extract-plugin
export default {"table":"Table_table__Rf4mU","pagination":"Table_pagination__ShLyo"};